import api from '../core/api';
export type {
  MasterCatalogGroup,
  MasterCatalogType,
  MasterSchema,
  MasterFieldDef,
} from '../../constants/masters';

export async function getMasterCatalog(opts?: { scope?: 'common' | 'service'; hub?: string; slug?: string }) {
  const res = await api.get('/admin/masters/catalog', { params: opts });
  return res.data.data as import('../../constants/masters').MasterCatalogGroup[];
}

export async function getMasterSchema(type: string) {
  const res = await api.get(`/admin/masters/schema/${type}`);
  return res.data.data as import('../../constants/masters').MasterSchema;
}

export async function getMasters(type: string, params?: {
  search?: string;
  page?: number;
  limit?: number;
  parentId?: string;
  rootsOnly?: boolean;
}) {
  const res = await api.get(`/admin/masters/${type}`, {
    params: {
      ...params,
      rootsOnly: params?.rootsOnly ? true : undefined,
    },
  });
  return res.data;
}

export async function createMaster(type: string, payload: Record<string, unknown>) {
  const res = await api.post(`/admin/masters/${type}`, payload);
  return res.data.data;
}

export async function updateMaster(id: string, payload: Record<string, unknown>) {
  const res = await api.put(`/admin/masters/${id}`, payload);
  return res.data.data;
}

export async function deleteMaster(id: string) {
  const res = await api.delete(`/admin/masters/${id}`);
  return res.data.data;
}

export async function getMasterOptions(
  type: string,
  params?: { parentType?: string; country?: string; state?: string }
) {
  const res = await api.get(`/admin/masters/${type}/parent-options`, { params });
  return res.data.data as Array<{
    _id: string;
    code: string;
    name: string;
    country?: string;
    state?: string;
    parentId?: string | null;
    currency?: string;
    timezone?: string;
    timezones?: string[];
    currencies?: string[];
  }>;
}

export async function bulkImportMasters(type: string, rows: Record<string, unknown>[]) {
  const res = await api.post(`/admin/masters/${type}/bulk-import`, { rows });
  return res.data.data as {
    created: number;
    updated: number;
    failed: { code: string; error: string }[];
  };
}

export async function seedBasicMasters() {
  const res = await api.post('/admin/masters/seed-basic');
  return res.data.data as {
    tenantId: string;
    tenantSlug: string;
    countries: boolean;
    geo: boolean;
    masters: boolean;
    porter: boolean;
    onDemand: boolean;
    masterCountAfter: number;
  };
}
